__turbopack_context__.v({
  "hero_background": "dB8jrG_hero_background",
  "hero_square_background": "dB8jrG_hero_square_background",
  "page_background": "dB8jrG_page_background",
  "row_background": "dB8jrG_row_background",
});
